import React, { Component } from 'react';
import { errorMessages, noDataFound } from '../../helpers/messages';

export default class ErrorMsgBlockComponent extends Component {
    render() {
        const { errorObject, noData, className, classListExplicit } = this.props;
        const classList = classListExplicit ? classListExplicit : `text-danger text-center bg-white rounded ${className ? className : 'py-4 m-0'}`

        return (
            <p className={classList}>
                {noData ?
                    noDataFound.noData
                    : errorObject?.message || errorObject?.errorMessage || errorMessages.generic
                }
            </p>
        )
    }
}